import { CollectionViewer, DataSource } from '@angular/cdk/collections';

import { ApiService } from '../../core/upgraded-providers';

import {
    from,
    Observable,
    BehaviorSubject
} from 'rxjs';
import { tap } from 'rxjs/operators';

export class HistoryDataSource implements DataSource<any> {
    private _dataSubject = new BehaviorSubject<any[]>([]);

    public page: number = 0;
    public length: number = 0;
    public hasNewer: boolean = false;
    public hasOlder: boolean = false;

    constructor(
        private _apiService: ApiService
    ) {
    }

    connect(collectionViewer: CollectionViewer): Observable<any[]> {
        return this._dataSubject.asObservable();
    }

    disconnect(collectionViewer: CollectionViewer): void {
        this._dataSubject.complete();
    }

    next({ page = 0, list, hasMore }) {
        this.length = list.length;

        this.page = page;
        this.hasNewer = page > 0;
        this.hasOlder = hasMore;

        this._dataSubject.next(list);
    }

    getData(page = 0): Observable<any> {
        return from(this._apiService
            .get('user/money-history', { page }))
            .pipe(tap((data) => this.next(data)));
    }

    getDetails(order): Observable<any> {
        return from(this._apiService
            .get('user/money-history/details', {
                tick: order.tick,
                roomName: order.market.roomName,
                targetRoomName: order.market.targetRoomName
            })
            .then(({ orders, users }) => {
                orders.forEach(({ user, type }) => {
                    if (type === 'market.sell') {
                        order.seller = users[user];
                    }

                    if (type === 'market.buy') {
                        order.buyer = users[user];
                    }
                });
            })
        );
    }
}
